import { get, put, destroy, upload, uploadPut } from 'utils/fetchRequest';

export const getActivePopup = async () => {
    try {
        return await get('popups/active');
    } catch (err) {
        return { error: err };
    }
};

export const getPopupList = async () => {
    try {
        return await get('popups');
    } catch (err) {
        return { error: err };
    }
};

export const createPopup = async (formData) => {
    try {
        return await upload('popups', formData);
    } catch (err) {
        return { error: err };
    }
};

export const updatePopup = async (id, formData) => {
    try {
        return await uploadPut(`popups/${id}`, formData);
    } catch (err) {
        return { error: err };
    }
};

export const activatePopup = async (id) => {
    try {
        return await put(`popups/${id}/activate`, {});
    } catch (err) {
        return { error: err };
    }
};

export const deactivatePopup = async (id) => {
    try {
        return await put(`popups/${id}/deactivate`, {});
    } catch (err) {
        return { error: err };
    }
};

export const deletePopup = async (id) => {
    try {
        return await destroy(`popups/${id}`);
    } catch (err) {
        return { error: err };
    }
};
